export const ClientOACstatus = {
  OAC: 'Yes',
  NON_OAC: 'No',
  NOT_AVAILABLE: 'Not available'
};
